export const collections = [
  {
    id: "c1",
    name: "录音剪辑之争合集",
    tag: "反转追踪",
    count: 46,
    update: "12 分钟前更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20flat%20lay%20of%20stacked%20folders%20and%20amber%20paper%20clips%20on%20charcoal%20desk%2C%20soft%20grain%2C%20no%20people%20no%20text%2C%20archive%20index%20mood&width=600&height=400&seq=kd-col-01&orientation=landscape",
  },
  {
    id: "c2",
    name: "旧图新用翻车现场",
    tag: "辟谣归档",
    count: 62,
    update: "1 小时前更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20close%20up%20of%20an%20old%20map%20with%20amber%20pins%20and%20threads%2C%20charcoal%20background%2C%20film%20grain%2C%20no%20people%20no%20text%2C%20tracing%20timeline%20mood&width=600&height=400&seq=kd-col-02&orientation=landscape",
  },
  {
    id: "c3",
    name: "各方声明原文库",
    tag: "声明汇总",
    count: 138,
    update: "今天 11:20 更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20still%20life%20of%20a%20handheld%20voice%20recorder%20and%20notebook%2C%20warm%20amber%20light%2C%20charcoal%20surface%2C%20soft%20grain%2C%20no%20people%20no%20text%2C%20interview%20note%20mood&width=600&height=400&seq=kd-col-03&orientation=landscape",
  },
  {
    id: "c4",
    name: "真假对照结果页",
    tag: "核验结论",
    count: 27,
    update: "昨天 22:08 更新",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20scene%20of%20a%20shield%20shaped%20stone%20on%20dark%20sand%20with%20amber%20glow%2C%20charcoal%20backdrop%2C%20film%20grain%2C%20no%20people%20no%20text%2C%20protection%20and%20verification%20mood&width=600&height=400&seq=kd-col-04&orientation=landscape",
  },
];

export const collectionStats = [
  { value: "18", label: "个在运营合集" },
  { value: "273", label: "条收录事件" },
  { value: "每周", label: "固定补一次时间线" },
];

export const events = [
  {
    id: "e1",
    featured: true,
    tag: "反转",
    title: "工作室称录音被剪辑，第二段视频放出后评论区风向变了",
    summary:
      "首条爆料帖称掌握完整内幕，工作室当晚回应称音频经过剪辑。次日爆料者补发第二段视频，却被网友指出画面前后帧不连贯，原本一边倒的评论区开始出现反问。本站已把两版说法并排列出，并补齐七个关键时间戳，等待平台方核查结论。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20dark%20editorial%20collage%20of%20torn%20paper%20strips%20and%20glowing%20amber%20threads%20crossing%2C%20charcoal%20backdrop%2C%20soft%20grain%2C%20no%20people%20no%20text%2C%20tension%20and%20contradiction%20mood&width=1200&height=800&seq=kd-ev-01&orientation=landscape",
    source: "站内核验组",
    time: "38 分钟前",
    updates: 27,
    heat: 96,
  },
  {
    id: "e2",
    tag: "辟谣",
    title: "网传聊天截图被证实为旧图重新拼接",
    summary:
      "截图右下角的状态栏机型与发布时间矛盾，原出处可追溯至两年前的另一事件。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20miniature%20scene%20of%20a%20small%20wooden%20gavel%20beside%20folded%20envelope%2C%20warm%20amber%20rim%20light%2C%20deep%20charcoal%20background%2C%20soft%20film%20grain%2C%20no%20people%20no%20text%2C%20quiet%20official%20tone&width=600&height=600&seq=kd-ev-02&orientation=squarish",
    source: "素材比对",
    time: "1 小时前",
    updates: 12,
    heat: 82,
  },
  {
    id: "e3",
    tag: "声明",
    title: "涉事品牌方发布书面说明，称已中止相关合作",
    summary:
      "声明共三段，未直接回应指控细节，仅强调合作已于上周终止并保留追责权利。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20still%20life%20of%20a%20retro%20microphone%20on%20dark%20table%20with%20warm%20amber%20glow%2C%20charcoal%20background%2C%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20no%20people%20no%20text%2C%20statement%20press%20conference%20mood&width=600&height=600&seq=kd-ev-03&orientation=squarish",
    source: "公开声明",
    time: "2 小时前",
    updates: 9,
    heat: 74,
  },
  {
    id: "e4",
    tag: "待核实",
    title: "直播回应里的三个时间点与通报存在二十分钟差口",
    summary:
      "观众整理了直播逐字稿，发现中间一段被跳过，暂无法确认是剪辑还是信号问题。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20scattered%20documents%20and%20a%20red%20seal%20stamp%2C%20warm%20amber%20lighting%2C%20deep%20charcoal%20surface%2C%20fine%20grain%2C%20no%20people%20no%20text%2C%20evidence%20sorting%20mood&width=600&height=600&seq=kd-ev-04&orientation=squarish",
    source: "逐字稿整理",
    time: "今天 10:14",
    updates: 15,
    heat: 68,
  },
  {
    id: "e5",
    tag: "更新",
    title: "平台方追加补充公告，公开部分后台操作日志",
    summary:
      "公告未下结论，但公开了账号登录设备与两条内容的时间记录，被视作关键进展。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20night%20city%20window%20reflection%20with%20amber%20street%20lights%20blurred%2C%20charcoal%20tones%2C%20soft%20film%20grain%2C%20no%20people%20no%20text%2C%20watching%20from%20afar%20mood&width=600&height=600&seq=kd-ev-05&orientation=squarish",
    source: "站内跟踪",
    time: "今天 09:02",
    updates: 21,
    heat: 63,
  },
];

export const eventFilters = ["全部", "反转", "辟谣", "声明", "待核实", "更新"];

export const statements = [
  {
    id: "s1",
    party: "涉事工作室",
    role: "第一轮回应",
    content:
      "网传音频并非原始完整版本，存在明显剪辑痕迹，我们已委托律师固定证据，保留追究相关账号责任的权利。",
    time: "09-08 23:15",
    source: "官方账号",
    verified: true,
  },
  {
    id: "s2",
    party: "平台安全团队",
    role: "核查进度",
    content:
      "已调取相关账号的后台操作日志，核查期间相关内容不作推荐处理，结论出来后会第一时间同步。",
    time: "09-09 09:02",
    source: "平台公告",
    verified: true,
  },
  {
    id: "s3",
    party: "爆料发布者",
    role: "补充素材",
    content:
      "原始文件不方便公开，但我可以再放一段视频，大家自己判断，别只听一方的说法。",
    time: "09-09 14:26",
    source: "个人账号",
    verified: false,
  },
  {
    id: "s4",
    party: "三名当事人",
    role: "同步发声",
    content:
      "我们从未参与所谓私下调解，相关行程有定位和航班记录可查，欢迎任何形式的核实。",
    time: "09-09 18:50",
    source: "联合声明",
    verified: true,
  },
  {
    id: "s5",
    party: "合作品牌方",
    role: "后续说明",
    content:
      "合作已于上周正式终止，与本次传闻无直接关联，后续不再就此事作额外回应。",
    time: "09-10 11:20",
    source: "书面说明",
    verified: true,
  },
  {
    id: "s6",
    party: "站内核验组",
    role: "本站标注",
    content:
      "比对七处时间戳后暂不下结论，目前状态为待核实，欢迎知情者补充可核验的原始材料。",
    time: "09-10 12:05",
    source: "本站编辑",
    verified: false,
  },
];

export const discussions = [
  {
    id: "d1",
    author: "不急着站队",
    initial: "不",
    tag: "对照整理",
    content:
      "把两版音频的波形对齐之后，中间那段的底噪完全对不上，建议等完整版出来再判断，别现在就给人定论。",
    time: "12 分钟前",
    likes: 328,
    replies: 64,
  },
  {
    id: "d2",
    author: "苔原观测员",
    initial: "苔",
    tag: "原始出处",
    content:
      "截图里的运营商套餐是去年就下架的款式，发布时间大概率对不上，这类旧图新用最近特别多。",
    time: "35 分钟前",
    likes: 256,
    replies: 41,
  },
  {
    id: "d3",
    author: "慢一拍吃瓜",
    initial: "慢",
    tag: "声明归档",
    content:
      "把今天所有声明按时间排了一遍，口径变化其实很小，主要差别在有没有提到合作终止这件事。",
    time: "1 小时前",
    likes: 199,
    replies: 28,
  },
  {
    id: "d4",
    author: "核验小分队",
    initial: "核",
    tag: "时间线",
    content:
      "补了一条被漏掉的直播切片，按新时间线看，二十分钟差口其实能解释，建议核验组重新标注。",
    time: "2 小时前",
    likes: 174,
    replies: 52,
  },
  {
    id: "d5",
    author: "路过的老瓜农",
    initial: "路",
    tag: "提问",
    content:
      "想问下有没有人存了第一版声明的截图，我这边只找到第二版，措辞好像不太一样。",
    time: "3 小时前",
    likes: 96,
    replies: 19,
  },
];